export default __webpack_public_path__ + "static/media/icons8-chain-intermidiate.6c974ae0.svg";